import React from "react";
import styled from "styled-components";
import {
  introduction,
  learningRightList,
  learningLeftList,
  serviceProvider,
} from "../../../utils/const/IntelligenceReportConsts";
import ReportGenerateTabs from "./ReportGenerateTabs";

export const Header = styled.div`
  font-size: 30px;
  margin: 20px 0px;
`;

const Table = styled.table`
  width: 600px;
`;

const Intro = styled.div`
  font-size: 16px;
`;

const Learning = styled.td`
  width: 300px;
  font-size: 16px;
`;

const Contact = styled.a`
  font-size: 16px;
  color: var(--color-brand-pink-primary);
`;

const IntReports = () => {
  return (
    <>
      <Header>Intelligence Reports</Header>
      <Intro>{introduction}</Intro>
      <Table>
        <tbody>
          <tr>
            <Learning>
              <ul>
                {learningLeftList.map((sentence) => (
                  <li key={sentence}>{sentence}</li>
                ))}
              </ul>
            </Learning>
            <Learning>
              <ul>
                {learningRightList.map((sentence) => (
                  <li key={sentence}>{sentence}</li>
                ))}
              </ul>
            </Learning>
          </tr>
        </tbody>
      </Table>
      <Intro>
        {serviceProvider}
        <Contact id="contactButton" href="mailto:data_research@checkpoint.com">
          {" "}
          contact us
        </Contact>
        .
      </Intro>
      <ReportGenerateTabs />
    </>
  );
};

export default IntReports;
